import TooltipEllipsis from '@deltek/specification-client/core/Feedbacks/TooltipEllipsis'
import React from 'react'

export interface CustomHoverTooltipProps {
    text: string
}

const CustomHoverTooltip = ({ text }: CustomHoverTooltipProps) => {
    return (
        <TooltipEllipsis text={text}>
            <span>{text}</span>
        </TooltipEllipsis>
    )
}

export default CustomHoverTooltip
